module.exports = __webpack_public_path__ + "static/media/reviewQuestionsIcon.779264c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/reviewQuestionsIcon.png
// module id = 1482
// module chunks = 0